import { toast } from 'react-toastify';

import { preferenceConstants } from '../constants';
import { GraphColorStyleEnum } from '../enums';
import { generalHelpers } from '../helpers';
import { COMMON_TOAST_SUCCESS_OPTIONS } from '../helpers/toast.helper';
import {
  getLangFromWindow,
  key_ATRInterval,
  key_avgVolInterval,
  key_changePercentageColumnV2,
  key_comparisonColorStyle,
  key_concentrationColorStyleV2,
  key_fontSize,
  key_graphColorStyle,
  key_histogramGroupType,
  key_histogramYellowSMA5,
  key_hkHistogramIndexType,
  key_hkStatisticsPageFilters,
  key_indexSMAIntervals,
  key_institutionalTradesVersion,
  key_lang,
  key_MAIntervals,
  key_marketSMAIntervals,
  key_MAType,
  key_minuteUnit,
  key_nopColorStyleV2,
  key_NOPStrategyVersion,
  key_participantNumChangeInterval,
  key_percentChangeV2,
  key_period,
  key_popUpNoticeModal,
  key_priceChangeInterval,
  key_priceRangeInterval,
  key_priceViewerLabelType,
  key_priceViewerTopN,
  key_priceViewerTurnoverOverlap,
  key_priceViewerVolumeOverlap,
  key_region,
  key_retailTradesVersion,
  key_returnTillNowV2,
  key_RSIInterval,
  key_showAAII,
  key_showATR,
  key_showBollingerBand,
  key_showFearGreedIndex,
  key_showHSIDividend,
  key_showHSIFundamental,
  key_showHSIPB,
  key_showHSIPE,
  key_showHSIShortRatio,
  key_showIndexSMA,
  key_showInstitutionalTrades,
  key_showMA,
  key_showMarketSMA,
  key_showMCAD,
  key_showNOPStrategy,
  key_showParticipantsNumber,
  key_showRetailTrades,
  key_showRSI,
  key_showShiftedParticipantsNumber,
  key_showSouthbound,
  key_showTopN,
  key_showWatchingList,
  key_stockTempMktcapV2,
  key_stockTempPriceV2,
  key_stockTempTurnoverV2,
  key_strategyMode,
  key_topN,
  key_unit,
  key_usHistogramIndexType,
  key_usStatisticsPageFilters,
  key_zoneActiveZones,
} from '../reducers/preference.reducer';
import { miscService } from '../services';
import { Filter, Language } from '../shared/types';
import { Region } from '../shared/types';
import { resetAbortController } from './utils';

export default {
  key_priceViewerVolumeOverlap,
  key_priceViewerTurnoverOverlap,
  key_showParticipantsNumber,
  key_showShiftedParticipantsNumber,
  key_showMA,
  key_MAType,
  key_MAIntervals,
  key_showRSI,
  key_RSIInterval,
  key_showMCAD,
  key_showBollingerBand,
  key_lang,
  key_region,
  key_period,
  key_unit,
  key_minuteUnit,
  key_fontSize,
  key_showIndexSMA,
  key_showHSIFundamental,
  key_indexSMAIntervals,
  key_showMarketSMA,
  key_marketSMAIntervals,
  key_graphColorStyle,
  key_nopColorStyleV2,
  key_concentrationColorStyleV2,
  key_comparisonColorStyle,
  key_showWatchingList,
  key_showRetailTrades,
  key_showInstitutionalTrades,
  key_priceViewerLabelType,
  key_retailTradesVersion,
  key_institutionalTradesVersion,
  key_popUpNoticeModal,
  key_showFearGreedIndex,
  key_showAAII,
  key_showHSIPE,
  key_showHSIPB,
  key_showHSIShortRatio,
  key_showHSIDividend,
  key_showSouthbound,
  key_returnTillNowV2,
  key_changePercentageColumnV2,
  key_stockTempPriceV2,
  key_stockTempMktcapV2,
  key_stockTempTurnoverV2,
  setPriceViewerVolumeOverlap,
  setChangePercentageColumn,
  setPriceViewerTurnoverOverlap,
  setPriceViewerMA,
  setPriceViewerMAType,
  setPriceViewerPeriod,
  setPriceViewerUnit,
  setPriceViewerMinuteUnit,
  setPriceViewerMAInterval,
  setPriceViewerRSI,
  setPriceViewerRSIInterval,
  setPriceViewerATR,
  setPriceViewerATRInterval,
  setPriceViewerMCAD,
  setPriceViewerBollingerBand,
  setPriceViewerParticipantsNumber,
  setPriceViewerShiftedParticipantsNumber,
  setPercentChange,
  setStockTempMktcap,
  setStockTempPrice,
  setStockTempTurnover,
  setReturnTillNow,
  switchLang,
  setRegion,
  setPriceChangeInterval,
  setPriceViewerTopN,
  setShowTopN,
  setTopN,
  setPriceRangeInterval,
  setAvgVolInterval,
  setParticipantNumChangeInterval,
  setStatisticsPageFilters,
  setPriceViewerIndexSMA,
  setPriceViewerIndexSMAInterval,
  setHSIFundamental,
  setPriceViewerMarketSMA,
  setPriceViewerMarketSMAInterval,
  setGraphColorStyle,
  setShowWatchingList,
  setHistogramYellowSMA5,
  setHistogramIndexType,
  setHistogramGroupType,
  setShowRetailTrades,
  setShowInstitutionalTrades,
  setPriceViewerLabelType,
  setRetailTradesVersion,
  setInstitutionalTradesVersion,
  setLineColorStyle,
  setZoneActiveZone,
  setPopUpNoticeModal,
  setPriceViewerFearGreedIndex,
  setPriceViewerAAII,
  setPriceViewerSouthbound,
  setPriceViewerNOPStrategy,
  setNOPStrategyVersion,
  setStrategyMode,
  setPriceViewerHSIPE,
  setPriceViewerHSIPB,
  setPriceViewerHSIDividend,
  setPriceViewerHSIShortRatio,
};

interface PreferenceAction<T> {
  type: string;
  key: string;
  value: T;
}

const generalPreferenceHandler = <T>(
  key: string,
  value: T,
  showBanner = false
) => {
  const ac = resetAbortController(preferenceConstants.SET_PREFERENCE + key);
  if (localStorage['user']) {
    miscService
      .storePreference(ac.signal, key, value)
      .then(() => {
        if (showBanner) {
          toast.success(
            getLangFromWindow() === 'zh' ? '已保存' : 'Saved',
            COMMON_TOAST_SUCCESS_OPTIONS
          );
        }
      })
      .catch(generalHelpers.noop);
  }
  return {
    type: preferenceConstants.SET_PREFERENCE,
    key,
    value,
  };
};

function setPriceViewerVolumeOverlap(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_priceViewerVolumeOverlap, value);
}
function setPriceViewerTurnoverOverlap(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_priceViewerTurnoverOverlap, value);
}

function setPriceViewerParticipantsNumber(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showParticipantsNumber, value);
}

function setPriceViewerShiftedParticipantsNumber(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showShiftedParticipantsNumber, value);
}

function setPriceViewerMA(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showMA, value);
}

function setPriceViewerMAType(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_MAType, value);
}

function setPriceViewerIndexSMA(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showIndexSMA, value);
}

function setHSIFundamental(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showHSIFundamental, value);
}

function setPriceViewerIndexSMAInterval(
  value: number[]
): PreferenceAction<number[]> {
  return generalPreferenceHandler(key_indexSMAIntervals, value);
}

function setPriceViewerMarketSMA(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showMarketSMA, value);
}

function setPriceViewerMarketSMAInterval(
  value: number[]
): PreferenceAction<number[]> {
  return generalPreferenceHandler(key_marketSMAIntervals, value);
}

function setPriceViewerPeriod(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_period, value);
}

function setPriceViewerUnit(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_unit, value);
}

function setPriceViewerMinuteUnit(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_minuteUnit, value);
}

function setPriceViewerMAInterval(value: string[]): PreferenceAction<string[]> {
  return generalPreferenceHandler(key_MAIntervals, value);
}

function setPriceViewerRSI(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showRSI, value);
}

function setPriceViewerRSIInterval(value: number): PreferenceAction<number> {
  return generalPreferenceHandler(key_RSIInterval, value);
}

function setPriceViewerATR(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showATR, value);
}

function setPriceViewerATRInterval(value: number): PreferenceAction<number> {
  return generalPreferenceHandler(key_ATRInterval, value);
}

function setPriceViewerMCAD(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showMCAD, value);
}

function setPriceViewerBollingerBand(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showBollingerBand, value);
}

function switchLang(value: Language): PreferenceAction<Language> {
  return generalPreferenceHandler(key_lang, value);
}

function setRegion(value: Region): PreferenceAction<Region> {
  return generalPreferenceHandler(key_region, value);
}

function setPriceChangeInterval(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_priceChangeInterval, value);
}

function setTopN(value: number): PreferenceAction<number> {
  return generalPreferenceHandler(key_topN, value);
}

function setPriceViewerTopN(value: number): PreferenceAction<number> {
  return generalPreferenceHandler(key_priceViewerTopN, value);
}

function setShowTopN(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showTopN, value);
}

function setPriceRangeInterval(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_priceRangeInterval, value);
}

function setAvgVolInterval(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_avgVolInterval, value);
}

function setParticipantNumChangeInterval(
  value: string
): PreferenceAction<string> {
  return generalPreferenceHandler(key_participantNumChangeInterval, value);
}

function setStatisticsPageFilters(
  region,
  value: any[]
): PreferenceAction<any[]> {
  const key =
    region === 'us' ? key_usStatisticsPageFilters : key_hkStatisticsPageFilters;
  return generalPreferenceHandler(key, value);
}

function setGraphColorStyle(
  value: GraphColorStyleEnum,
  showBanner: boolean
): PreferenceAction<GraphColorStyleEnum> {
  return generalPreferenceHandler(key_graphColorStyle, value, showBanner);
}

function setLineColorStyle(
  key: string,
  value: string,
  showBanner: boolean
): PreferenceAction<string> {
  return generalPreferenceHandler(key, value, showBanner);
}

function setShowWatchingList(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showWatchingList, value);
}

function setHistogramYellowSMA5(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_histogramYellowSMA5, value);
}

function setHistogramIndexType(
  region,
  value: string[]
): PreferenceAction<string[]> {
  const key =
    region === 'us' ? key_usHistogramIndexType : key_hkHistogramIndexType;
  return generalPreferenceHandler(key, value);
}

function setHistogramGroupType(value: string[]): PreferenceAction<string[]> {
  return generalPreferenceHandler(key_histogramGroupType, value);
}

function setShowRetailTrades(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showRetailTrades, value);
}

function setShowInstitutionalTrades(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showInstitutionalTrades, value);
}

function setPriceViewerLabelType(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_priceViewerLabelType, value);
}

function setRetailTradesVersion(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_retailTradesVersion, value);
}

function setInstitutionalTradesVersion(
  value: string
): PreferenceAction<string> {
  return generalPreferenceHandler(key_institutionalTradesVersion, value);
}

function setZoneActiveZone(value: string[]): PreferenceAction<string[]> {
  return generalPreferenceHandler(key_zoneActiveZones, value);
}

function setPopUpNoticeModal(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_popUpNoticeModal, value);
}

function setPriceViewerFearGreedIndex(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showFearGreedIndex, value);
}

function setPriceViewerAAII(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showAAII, value);
}

function setPriceViewerSouthbound(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showSouthbound, value);
}

function setPriceViewerNOPStrategy(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showNOPStrategy, value);
}
function setNOPStrategyVersion(value: string): PreferenceAction<string> {
  return generalPreferenceHandler(key_NOPStrategyVersion, value);
}

function setStrategyMode(
  value,
  showBanner: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_strategyMode, value, showBanner);
}

function setPriceViewerHSIPE(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showHSIPE, value);
}
function setPriceViewerHSIPB(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showHSIPB, value);
}

function setPriceViewerHSIDividend(value: boolean): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showHSIDividend, value);
}
function setPriceViewerHSIShortRatio(
  value: boolean
): PreferenceAction<boolean> {
  return generalPreferenceHandler(key_showHSIShortRatio, value);
}

function setPercentChange(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_percentChangeV2, value);
}

function setStockTempMktcap(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_stockTempMktcapV2, value);
}

function setStockTempPrice(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_stockTempPriceV2, value);
}

function setStockTempTurnover(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_stockTempTurnoverV2, value);
}

function setReturnTillNow(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_returnTillNowV2, value);
}

function setChangePercentageColumn(value: Filter): PreferenceAction<Filter> {
  return generalPreferenceHandler(key_changePercentageColumnV2, value);
}
